module.exports = __webpack_public_path__ + "img/glodal-var.469a382d.svg";